{ "closeAria": "Cerrar", "historyAria": "Historial de solicitudes", "supportTitle": "Soporte" }
